import { Navbar } from "@/components/sections/Navbar";
import { Footer } from "@/components/sections/Footer";
import { SubtleWaves } from "@/components/ui/waves";
import { Globe, Shield, Cookie, Database, Lock, UserCheck, Mail } from "lucide-react";

export const PrivacyPage = () => {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <SubtleWaves />
        <div className="absolute inset-0 bg-gradient-lavender opacity-30" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-serif text-4xl md:text-6xl font-bold text-foreground mb-6 animate-fade-in-up text-glow">
              Privacyverklaring
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed animate-fade-in-up delay-200">
              Privacy Policy
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="relative py-20 bg-gradient-to-b from-background to-emerald-50/30">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-16">
            
            {/* Nederlands Section */}
            <div className="bg-card rounded-2xl border-2 border-gold/20 p-8 md:p-12 shadow-lg">
              <div className="flex items-center gap-3 mb-8">
                <Globe className="w-8 h-8 text-gold" />
                <h2 className="font-serif text-3xl font-bold text-foreground">Nederlands 🇳🇱</h2>
              </div>
              
              <div className="prose prose-lg max-w-none space-y-6">
                <p className="text-muted-foreground leading-relaxed">
                  Lunssence respecteert uw privacy en behandelt uw persoonlijke gegevens zorgvuldig. In deze privacyverklaring leggen we uit welke gegevens we verzamelen, waarom we dat doen, en wat uw rechten zijn.
                </p>

                <div className="space-y-6 mt-8">
                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Database className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        1. Welke gegevens verzamelen wij?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Bij het plaatsen van een bestelling verzamelen wij: naam, e-mailadres, leveradres, telefoonnummer en betaalgegevens. Voor onze nieuwsbrief verzamelen we alleen uw e-mailadres. We verzamelen ook technische gegevens zoals IP-adres en browser-informatie voor websitebeveiliging.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <UserCheck className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        2. Waarvoor gebruiken wij uw gegevens?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Wij gebruiken uw gegevens om: bestellingen te verwerken en verzenden, contact met u op te nemen over uw bestelling, klantenservice te bieden, onze nieuwsbrief te versturen (indien u zich heeft aangemeld), onze website te verbeteren en fraude te voorkomen.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Shield className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        3. Delen wij uw gegevens?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Wij delen uw gegevens alleen met: verzendpartners (voor levering), betaaldiensten (iDEAL, Klarna, PayPal) en e-mailserviceproviders (voor nieuwsbrieven). We verkopen of verhuren uw gegevens nooit aan derden voor marketingdoeleinden.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Lock className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        4. Hoe beveiligen wij uw gegevens?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen verlies, misbruik of ongeautoriseerde toegang. Alle betaalgegevens worden beveiligd verwerkt via onze betaaldiensten.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Cookie className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        5. Cookies
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Onze website gebruikt functionele cookies om de website goed te laten werken. We gebruiken ook analytische cookies om te begrijpen hoe bezoekers onze website gebruiken. U kunt cookies uitschakelen via uw browserinstellingen.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <UserCheck className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        6. Uw rechten (AVG/GDPR)
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      U heeft het recht om: inzage te krijgen in uw gegevens, uw gegevens te laten corrigeren of verwijderen, bezwaar te maken tegen gebruik van uw gegevens, gegevensoverdracht aan te vragen. Neem contact met ons op via info@lunssence.com voor het uitoefenen van uw rechten.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Database className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        7. Bewaartermijn
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Wij bewaren uw gegevens niet langer dan noodzakelijk. Bestellingsgegevens bewaren we 7 jaar (wettelijke verplichting). Nieuwsbriefadressen bewaren we totdat u zich afmeldt. Technische data bewaren we maximaal 1 jaar.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Mail className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        8. Vragen of klachten?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Heeft u vragen of klachten over hoe wij met uw gegevens omgaan? Neem dan contact met ons op via info@lunssence.com. U kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* English Section */}
            <div className="bg-card rounded-2xl border-2 border-gold/20 p-8 md:p-12 shadow-lg">
              <div className="flex items-center gap-3 mb-8">
                <Globe className="w-8 h-8 text-gold" />
                <h2 className="font-serif text-3xl font-bold text-foreground">English 🇬🇧</h2>
              </div>
              
              <div className="prose prose-lg max-w-none space-y-6">
                <p className="text-muted-foreground leading-relaxed">
                  Lunssence respects your privacy and handles your personal data with care. This privacy policy explains what data we collect, why we do so, and what your rights are.
                </p>

                <div className="space-y-6 mt-8">
                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Database className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        1. What data do we collect?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      When placing an order, we collect: name, email address, delivery address, phone number, and payment information. For our newsletter, we only collect your email address. We also collect technical data such as IP address and browser information for website security.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <UserCheck className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        2. How do we use your data?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      We use your data to: process and ship orders, contact you about your order, provide customer service, send newsletters (if you subscribed), improve our website, and prevent fraud.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Shield className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        3. Do we share your data?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      We only share your data with: shipping partners (for delivery), payment services (iDEAL, Klarna, PayPal), and email service providers (for newsletters). We never sell or rent your data to third parties for marketing purposes.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Lock className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        4. How do we secure your data?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      We take appropriate technical and organizational measures to protect your data against loss, misuse, or unauthorized access. All payment data is securely processed through our payment services.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Cookie className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        5. Cookies
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Our website uses functional cookies to ensure proper operation. We also use analytical cookies to understand how visitors use our website. You can disable cookies via your browser settings.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <UserCheck className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        6. Your rights (GDPR)
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      You have the right to: access your data, correct or delete your data, object to use of your data, request data transfer. Contact us at info@lunssence.com to exercise your rights.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Database className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        7. Retention period
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      We do not keep your data longer than necessary. We retain order data for 7 years (legal requirement). Newsletter addresses are kept until you unsubscribe. Technical data is retained for a maximum of 1 year.
                    </p>
                  </div>

                  <div className="border-l-4 border-gold pl-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Mail className="w-5 h-5 text-gold" />
                      <h3 className="font-serif text-xl font-bold text-foreground">
                        8. Questions or complaints?
                      </h3>
                    </div>
                    <p className="text-muted-foreground">
                      Do you have questions or complaints about how we handle your data? Contact us at info@lunssence.com. You can also file a complaint with the Dutch Data Protection Authority.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gradient-to-br from-gold/10 to-emerald-50/30 rounded-2xl p-8 md:p-12 border border-gold/20">
              <div className="flex items-center gap-3 mb-6">
                <Mail className="w-6 h-6 text-gold" />
                <h3 className="font-serif text-2xl font-bold text-foreground">Contact</h3>
              </div>
              <div className="space-y-2 text-muted-foreground">
                <p><strong className="text-foreground">Lunssence</strong></p>
                <p>Amsterdam, Nederland</p>
                <p>
                  <a href="mailto:info@lunssence.com" className="text-gold hover:underline">
                    info@lunssence.com
                  </a>
                </p>
                <p>
                  <a href="https://www.lunssence.com" className="text-gold hover:underline" target="_blank" rel="noopener noreferrer">
                    www.lunssence.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
